<template>
  <div class="book-container">
    <!-- 头部导航 -->
    <van-nav-bar 
      :title="navTitle" 
     
      @click-left="onClickLeft" 
      fixed 
      placeholder 
      class="dark-nav"
    />

    <!-- 分类区域 -->
    <div v-show="!showAccountCenter">
      <div class="category-container" v-if="!['purchased', 'favorite'].includes(activeTab)">
      <div class="sub-category-grid">
        <div 
          class="sub-cat-tag" 
          :class="{ active: !activeCateId  }"
          @click="activeCateId=0"
        >
          全部
        </div>
        <div 
          class="sub-cat-tag" 
          v-for="(item, index) in categoryList" 
          :key="item.id || index"
          v-if="item?.id!=''"
          :class="{ active: activeCateId === item.id }"
          @click="onCategoryChange(item)"
        >
          {{ item.category_name }}
        </div>
        <div class="searcn-new-book" :style="{ background: `linear-gradient(to right, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }"
         @click="webspread"> <i class="fa fa-angle-double-down" style="color:#E44E3A;margin-right: 4px;font-weight: 700;"></i>账户中心 </div>
              
      </div>
    </div>

    <!-- 列表区域 (一排两个，暗黑奢华卡片) -->
    <div class="list-container">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="dark-refresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多内容了"
          @load="onLoad"
        >
          <div class="book-grid">
            <div class="book-card"  v-for="item in bookList" :key="item.id" @click="goToDetail(item)">
                <!-- 封面区域 -->
              <div class="cover-wrapper">
                <img class="cover-img" :id="item.number ? item.number + '_img' : 'img_' + item.id" :src="item.is_new === 1 ? item.cover : ''" style="object-fit: cover;" />
                
                <!-- 类型角标 -->
                <div class="type-badge">{{ item.type }}</div>
                <!-- 状态角标 -->
                <div class="status-badge" v-if="item.statusText">{{ item.statusText }}</div>
              </div>
              
              <!-- 底部信息区域 -->
              <div class="book-info">
                <!-- 标题 -->
                <div class="book-title">
                  {{ item.title }}
                </div>
                
                <!-- 小说分类 -->
                <div class="book-time">
                  分类: {{ item.categoryText }}
                </div>
                
                <!-- 数据统计 -->
                <div class="book-stats">
                  <span class="stat-item">
                    <van-icon name="eye-o" style="    margin-top: 3px;"/> <span class="stat-item">{{ formatCount(item.viewCount) }}</span>
                  </span>
                  <span class="stat-item">
                    <van-icon name="star-o" class="star-icon" /> {{ formatCount(item.favoriteCount) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    </div>

    <!-- 个人中心 (账户中心) -->
    <div class="user-center" v-show="showAccountCenter">
      <div class="user-card-wrap">
        <div class="user-card-inner">
          <div class="user-avatar">
            <img src="data:image/jpeg;base64,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" alt="avatar" />
          </div>
          <div class="user-account" style="color:#fff;">账号: {{ userInfo.username || '非会员' }}</div>
          <div class="user-code" style="color:#fff;">
            播放口令: {{ shareDataInfo.shareAgentCode || '未获取' }}
            <span class="copy-btn-yellow" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</span>
          </div>
          <div class="user-vip-status">
            <div class="vip-tag" style="color:#fff;" v-if="!vipInfo.is_vip">
              <van-icon name="gem-o" /> 您还不是本站的VIP会员
            </div>
            <div class="vip-tag is-vip" style="color:#fff;" v-else>
              <van-icon name="gem" /> 尊敬的VIP会员
            </div>
          </div>
        </div>
      </div>

      <div class="user-action-btns">
        <div class="action-btn-item" @click="showLoginBox=true" v-if="!userInfo.username">登录&注册</div>
        <div class="action-btn-item" @click="handleLogout" v-else>退出登录</div>
        <div class="action-btn-item" @click="goHome">返回首页</div>
      </div>

      <div class="menu-list" style="margin-bottom: 20px; border-radius: 10px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.05);">
        <van-cell-group :border="false">
          <van-cell title="我的收藏" icon="like-o" is-link @click="onTabClick('favorite'); showAccountCenter=false" />
          <van-cell title="我的购买" icon="bag-o" is-link @click="onTabClick('purchased'); showAccountCenter=false" />
          <van-cell title="收藏站点" icon="star-o" is-link @click="showRemindBox=true" />
          <van-cell title="找回购买记录" icon="search" is-link @click="findBox=true" />
        </van-cell-group>
      </div>

      <div class="user-tips-box">
        <div class="tips-icon"><van-icon name="info-o" /></div>
        <div class="tips-text">
          温馨提示：如果您之前已购买过，没有正常显示，可能是您的网络环境发生了变化，可尝试通过当时购买时的播放口令码进行重新绑定观看。
        </div>
      </div>

      <div class="tousu-float-btn" @click="$toast('暂未开放')">投诉</div>
    </div>
    <!-- 个人中心 (账户中心) -->

    <!-- 底部炫酷导航栏 -->
    <div class="cyber-tabbar" :style="{ background: `linear-gradient(to right, ${color || '#6197B1'}, ${backcolor || '#B4CCF6'})` }">
      <div class="tab-item" :class="{ active: activeTab === 'home' }" @click="onTabClick('home')">
        <van-icon name="video-o" class="tab-icon" />
        <span class="tab-text">热门视频</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'book' }" @click="onTabClick('book')">
        <van-icon name="fire-o" class="tab-icon" />
        <span class="tab-text">热门小说</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'purchased' }" @click="onTabClick('purchased')">
        <van-icon name="bag-o" class="tab-icon" />
        <span class="tab-text">已购买</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'favorite' }" @click="onTabClick('favorite')">
        <van-icon name="like-o" class="tab-icon" />
        <span class="tab-text">已收藏</span>
      </div>
    </div>

    <div class="cebian" v-if="activeTab === 'purchased'">
      <div class="ce-shesu" @click="findBox=true">找回</div>
      
    </div>

    <!-- 收藏站点弹窗 -->
    <van-popup v-model="showRemindBox" 
      closeable
      round 
      close-icon-position="top-right"
      popup-background-color="#ffffff"
      position="center" :style="{ minHeight: '55%' ,width:'90%' }" >
      
      <div class="remind-box">
          <div class="remind-box-title"> 收藏站点 永不迷路</div>
          <div class="remind-title-tips">{{shareDataInfo.book_tip_content}}</div>
          
          <div class="remind-box-tip1">永久网址:</div>
          <div class="remind-box-link">
            <div class="box-link">{{ shareDataInfo.show_book_tip_url }}</div>
            <div class="box-copy" @click="handelClickCopy(shareDataInfo.show_book_tip_url)">复制</div>
          </div>
          
          <div style="display: flex;align-items: center;justify-content: center;margin-top: 10px;">
            <div class="remind-box-tip1" >找回码:</div>
            <div class="remind-box-link">
              <div class="box-link" style="color:red;background-color: #FEEEF0;padding:2px 4px;border-radius: 5px;">{{shareDataInfo.shareAgentCode}}</div>
              <div class="box-copy" @click="handelClickCopy(shareDataInfo.shareAgentCode)">复制</div>
            </div>
          </div>

          <div class="qrcode-section">
            <div class="remind-box-tip1">截图保存本站二维码:</div>
            <div class="qrcode-wrapper">
              <img v-if="shareDataInfo.qrcodeLink" :src="shareDataInfo.qrcodeLink" class="remind-poster-img" alt="收藏二维码" />
            </div>
          </div>
      </div>
    </van-popup>

    <!-- 找回购买记录弹窗 -->
    <van-popup v-model="findBox" round closeable>
        <div class="code-box-card">
          <h3 class="code-box-title">找回购买记录</h3>
          <div class="code-content">
                <p class="code-txt">识别码</p>
              <input class="code-input" v-model="video_code" placeholder="请输入识别码"/>
            </div>
            <div class="code-tips">
                请填写您的口令识别码
            </div>
            <div style=""> 
              <div class="code-btn btn-grad1" @click="findCodeLog">立即找回</div>
            </div>
            
        </div>
    </van-popup>

    <!-- 登录注册弹窗 -->
    <van-popup v-model="showLoginBox" round closeable position="bottom" :style="{ height: '65%' }">
      <div class="login-box-wrap">
        <div class="login-header">账号登录 / 注册</div>
        <van-tabs v-model="loginTab" class="login-tabs-custom" color="#44A4FF" title-active-color="#44A4FF" :line-width="30" :line-height="3">
          <van-tab title="用户登录">
            <div class="form-container" style="margin-top: 25px;">
              <van-field v-model="loginForm.username" class="custom-field" placeholder="请输入账号" clearable />
              <van-field v-model="loginForm.password" class="custom-field" type="password" placeholder="请输入密码" clearable />
            </div>
            <div class="submit-btn-wrap">
              <van-button class="custom-submit-btn" type="info" block round @click="handleLogin">立 即 登 录</van-button>
            </div>
          </van-tab>
          <van-tab title="注册新账号">
            <div class="form-container" style="margin-top: 25px;">
              <van-field v-model="regForm.username" class="custom-field" placeholder="请输入注册账号" clearable />
              <van-field v-model="regForm.password" class="custom-field" type="password" placeholder="请输入注册密码" clearable />
              <van-field v-model="regForm.repassword" class="custom-field" type="password" placeholder="请再次确认密码" clearable />
            </div>
            <div class="submit-btn-wrap">
              <van-button class="custom-submit-btn" type="info" block round @click="handleRegister">立 即 注 册</van-button>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </van-popup>
    <!-- 登录注册弹窗 -->
  </div>

</template>

<script>
import { bksApi, bksListApi, booksBuyApi, booksCollectionListApi, iv6Api, userLoginApi, userRegisterApi, UserInfoApi, gvcodApi } from "@/api/api";
import QRCode from "qrcode";

export default {
  name: 'BookList',
  data() {
    return {
      categoryList: [], // 一级分类数据
      activeCateId: 0,
      
      bookList: [],
      loading: false,
      finished: false,
      refreshing: false,
      
      params: {
        cate_id: 0,
        key: '',
        ldk: '',
        payed: 0,
        uid: '',
        page: 1,
        limit: 10,
        templete_id: 1,
        webmanage: 0,
      },
      
      activeTab: 'book', // 默认激活小说列表状态
      color: '',
      backcolor: '',
      shareDataInfo:{
        book_tip_content:'',
        tip_image:'',
        show_book_tip_url:'',
        tipUrlList:[],
        shareAgentCode:'',
        qrcodeLink:'',
        is_live:0
      },
      // 个人中心相关
      showAccountCenter: false,
      showLoginBox: false,
      loginTab: 0,
      loginForm: {
        username: '',
        password: '',
        code: ''
      },
      regForm: {
        username: '',
        password: '',
        repassword: ''
      },
      userInfo: {
        username: ''
      },
      vipInfo: {
        is_vip: 0
      },
      // 收藏站点弹窗
      showRemindBox: false,
      remindPosterUrl: '',
      // 找回弹窗
      findBox: false,
      video_code: '',
      shibieCode: '******',
      shareAgentCode: '',
    };
  },
  computed: {
    navTitle() {
      if (this.activeTab === 'purchased') return '已购资源';
      if (this.activeTab === 'favorite') return '我的收藏';
      return '小说资源';
    }
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        if (newTab) {
          this.activeTab = newTab;
          this.onRefresh();
        }
      },
      immediate: true
    },
    showRemindBox(newVal) {
      if (newVal) {
        this.generateRemindPoster();
      }
    }
  },
  created() {
    this.color = window.localStorage.getItem('color');
    this.backcolor = window.localStorage.getItem('backcolor');
    this.params.ldk = window.localStorage.getItem('ldk') || '';
    this.params.uid = window.localStorage.getItem('visitorId') || '';
    this.setInitData();
    this.getInitData();
    this.getCategoryList();
    this.getUserInfo();
  },
  methods: {
    setInitData(){
        let templete_id=this.getURLParameter('kt');
          if(!templete_id || templete_id=='undefined'){
            let old_tem=window.localStorage.getItem('templete_id');
            if(old_tem && old_tem=='undefined'){
              templete_id=old_tem;
            }else{
              templete_id=1;
            }
          }
        
        this.params.templete_id=templete_id;
        window.localStorage.setItem('templete_id',templete_id);
        this.params.ldk=this.getURLParameter('ldk');
        this.params.uid=this.getURLParameter('uid');
        if(!this.params.ldk || this.params.ldk=='undefined' || this.params.ldk==''){
          let ldk=this.getKey('ldk');
          if(!ldk){
            this.params.ldk=window.localStorage.getItem('ldk');
          }else{
            this.params.ldk=ldk;
            window.localStorage.setItem('ldk',ldk);
          }
          
        }
        if(!this.params.uid || this.params.uid=='undefined' || this.params.uid==''){
          this.params.uid=window.localStorage.getItem('visitorId');
        }
       
       
      },
    getURLParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    getKey(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.hash);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    getInitData(){
      let that=this;
      iv6Api({ldk: that.params.ldk, payed: that.params.payed,shebei_type:that.shebei_type}).then(res=>{
        let temp=JSON.parse(that.$decryptData(res));
        
        if(temp.agenturl && temp.agenturl!=''){
          window.location.href=temp.agenturl;
        }
        that.color=temp.color;
        that.backcolor=temp.backcolor;
        window.localStorage.setItem('color',temp.color);
        window.localStorage.setItem('backcolor',temp.backcolor);
        setTimeout(()=>{
          that.showContent=true;
        },500);
        that.payList=temp.payList;
        that.payBtnList=JSON.parse(that.$decryptData(temp.payBtnList));
        that.shareDataInfo.book_tip_content=temp.book_tip_content;
        that.shareDataInfo.tip_image=temp.tip_image;
        that.shareDataInfo.show_book_tip_url=temp.show_book_tip_url;
        that.shareDataInfo.tipUrlList=temp.tipUrlList;
        that.shareDataInfo.shareAgentCode=temp.shareAgentCode;
        that.shareDataInfo.is_live=temp.is_live;
        window.localStorage.setItem('shareAgentCode',temp.shareAgentCode);
        if(temp.is_index==1){
            if(temp.is_poster==1){
              that.showPosterBox=true;
            }else{
              that.showRemindBox=true;
              that.generateRemindPoster();
            }
          }
        window.localStorage.setItem('localPayBtnList',temp.payBtnList);
        window.localStorage.setItem('jiekou',temp.jiekou);
        window.localStorage.setItem('payList',JSON.stringify(temp.payList));
        window.localStorage.setItem('IP',temp.ip);
      
      
      })
    },
    webspread(){
      this.showAccountCenter = true;
    },
    goHome(){
      this.showAccountCenter = false;
      //this.$router.push('/');
    },
    handelClickCopy(text){
      this.$copyText(text).then(e=>{
        this.$toast('复制成功');
      }).catch(e=>{
        this.$toast('复制失败');
      })
    },
    handleLogin() {
      if (!this.loginForm.username || !this.loginForm.password) {
        return this.$toast('请输入账号和密码');
      }
      userLoginApi(this.loginForm).then(res => {
        if (res && res.code === 1) {
          this.$toast('登录成功');
          this.userInfo = res.data;
          if (res.data.shareAgentCode) {
            this.shareDataInfo.shareAgentCode = res.data.shareAgentCode;
            window.localStorage.setItem('shareAgentCode', res.data.shareAgentCode);
          }
          window.localStorage.setItem('Authorization', res.data.token);
          this.showLoginBox = false;
        }
      });
    },
    getUserInfo(){
      UserInfoApi().then(res => {
        let temp = JSON.parse(this.$decryptData(res));
        if (temp.is_login === 1) {
          if (temp.user) {
            this.shareDataInfo.shareAgentCode = temp.user.shareAgentCode;
            window.localStorage.setItem('shareAgentCode', temp.user.shareAgentCode);
            this.userInfo = temp.user;
          }
        }
      });
    },
    handleRegister() {
      if (!this.regForm.username || !this.regForm.password || !this.regForm.repassword) {
        return this.$toast('请填写完整注册信息');
      }
      if (this.regForm.password !== this.regForm.repassword) {
        return this.$toast('两次密码不一致');
      }
      const submitData = {
        ...this.regForm,
        shareAgentCode: this.shareDataInfo.shareAgentCode
      };
      userRegisterApi(submitData).then(res => {
        if (res && res.code === 1) {
          this.$toast('注册成功，请登录');
          this.loginTab = 0;
          this.loginForm.username = this.regForm.username;
        }
      });
    },
    handleLogout() {
      this.userInfo = { username: '' };
      window.localStorage.removeItem('shareAgentCode');
      window.localStorage.removeItem('Authorization');
      this.$toast('已退出登录');
    },
    // 找回购买记录
    findCodeLog(){
      let that=this;
      if(!that.video_code){
        that.$toast('请填写识别码');
        return ;
      }
      gvcodApi({code:that.video_code,ldk:that.params.ldk}).then(res=>{
        let temp=JSON.parse(that.$decryptData(res));
        that.$toast(temp.msg);
        if(temp.code==1){
          that.findBox=false;
          that.video_code='';
          that.onTabClick('purchased');
        }
      });
    },
    // 生成收藏站点海报
    async generateRemindPoster(){
      const mainUrl = this.shareDataInfo.show_book_tip_url;
      if (!mainUrl) {
        this.remindPosterUrl = '';
        return;
      }
      try {
        const tempCanvas = document.createElement('canvas');
        const tempCtx = tempCanvas.getContext('2d');
        tempCtx.font = '28px Arial';
        const urlLines = this.wrapCanvasText(tempCtx, mainUrl, 630);

        const qrDataUrl = await QRCode.toDataURL(mainUrl, {
          width: 260,
          margin: 1
        });
        
        this.shareDataInfo.qrcodeLink = qrDataUrl;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const width = 750;
        const height = 1000;
        canvas.width = width;
        canvas.height = height;

        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);

        let cursorY = 80;

        ctx.fillStyle = '#333333';
        ctx.font = 'bold 40px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('收藏站点 永不迷路', width / 2, cursorY);
        
        cursorY += 40;
        ctx.strokeStyle = '#f5f5f5';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(40, cursorY);
        ctx.lineTo(width - 40, cursorY);
        ctx.stroke();

        cursorY += 60;
        ctx.fillStyle = '#f53036';
        ctx.font = 'bold 28px Arial';
        const tipLines = this.wrapCanvasText(ctx, this.shareDataInfo.book_tip_content || '温馨提示：请妥善保管好我们的网址，以免丢失。每天更新最新资源，超清，超快，超好看！', width - 120);
        tipLines.forEach((line) => {
          ctx.fillText(line, width / 2, cursorY);
          cursorY += 42;
        });

        cursorY += 30;
        ctx.textAlign = 'center';
        ctx.fillStyle = '#333333';
        ctx.font = '28px Arial';
        ctx.fillText('永久网址：', width / 2, cursorY);

        cursorY += 50;
        ctx.fillStyle = '#44A4FF';
        ctx.font = 'bold 34px Arial';
        ctx.textAlign = 'right';
        ctx.fillText(mainUrl, width / 2 + 50, cursorY);
        
        ctx.fillStyle = '#44A4FF';
        this.roundRect(ctx, width / 2 + 70, cursorY - 32, 90, 44, 10);
        ctx.fill();
        ctx.fillStyle = '#ffffff';
        ctx.font = '22px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('复制', width / 2 + 115, cursorY - 2);

        cursorY += 70;
        ctx.fillStyle = '#333333';
        ctx.font = '28px Arial';
        ctx.textAlign = 'right';
        ctx.fillText('当前用户口令：', width / 2 - 40, cursorY);
        
        ctx.fillStyle = '#44A4FF';
        ctx.font = 'bold 34px Arial';
        ctx.textAlign = 'left';
        ctx.fillText(this.shareDataInfo.shareAgentCode || '******', width / 2 - 30, cursorY);
        
        ctx.fillStyle = '#44A4FF';
        this.roundRect(ctx, width / 2 + 160, cursorY - 32, 90, 44, 10);
        ctx.fill();
        ctx.fillStyle = '#ffffff';
        ctx.font = '22px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('复制', width / 2 + 205, cursorY - 2);

        cursorY += 80;
        ctx.fillStyle = '#333333';
        ctx.font = '28px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('截图保存本站二维码：', width / 2, cursorY);

        const qrImage = await this.loadCanvasImage(qrDataUrl);
        const qrSize = 340;
        const qrY = cursorY + 30;
        ctx.drawImage(qrImage, (width - qrSize) / 2, qrY, qrSize, qrSize);

        this.remindPosterUrl = canvas.toDataURL('image/png');
      } catch (error) {
        console.error('生成提醒海报失败:', error);
        this.remindPosterUrl = '';
      }
    },
    roundRect(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
    },
    wrapCanvasText(ctx, text, maxWidth) {
      if (!text) return [];
      const lines = [];
      let currentLine = '';
      for (const char of text) {
        const testLine = currentLine + char;
        if (ctx.measureText(testLine).width > maxWidth && currentLine) {
          lines.push(currentLine);
          currentLine = char;
        } else {
          currentLine = testLine;
        }
      }
      if (currentLine) {
        lines.push(currentLine);
      }
      return lines;
    },
    loadCanvasImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },
    // 获取分类列表
    getCategoryList() {
      bksApi({ ldk: this.params.ldk }).then(res => {
        this.categoryList = [{ id: 0, name: '全部' }];
        if (res) {
          let list = JSON.parse(this.$decryptData(res));
          list.forEach(item => {
            this.categoryList.push(item);
          });
        }
      });
    },
    // 底部导航点击
    onTabClick(tab) {
      if (tab === 'home') {
        this.$router.push('/');
      } else {
        this.showAccountCenter = false;
        this.activeTab = tab;
        this.onRefresh();
      }
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 切换分类
    onCategoryChange(item) {
      this.activeCateId = item.id;
      this.params.cate_id = item.id;
      this.onRefresh();
    },
    // 下拉刷新
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.params.page = 1;
      this.bookList = [];
      this.onLoad();
    },
    // 上拉加载更多
    onLoad() {
      if (this.refreshing) {
        this.bookList = [];
        this.refreshing = false;
      }
      
      this.params.sp = window.localStorage.getItem('sp');
      this.params.ua = window.localStorage.getItem('parent');
      
      let apiCall;
      if (this.activeTab === 'purchased') {
        apiCall = booksBuyApi(this.params);
      } else if (this.activeTab === 'favorite') {
        apiCall = booksCollectionListApi(this.params);
      } else {
        apiCall = bksListApi(this.params);
      }
      
      apiCall.then(res => {
        this.loading = false;
        if (res) {
          let temp = JSON.parse(this.$decryptData(res));
         
          if (temp.data && temp.data.length > 0) {
            let newData = temp.data.map(item => {
              // 寻找当前分类名称
              let typeName = '小说';
              let cate = this.categoryList.find(c => c.id === this.params.cate_id);
              if (cate && cate.name !== '全部') {
                typeName = cate.name;
              } else if (item.novel_type_text) {
                typeName = item.novel_type_text;
              } else if (item.cate_name) {
                typeName = item.cate_name;
              }
              
              return {
                id: item.id,
                title: item.novel_title || item.title,
                cover: item.cover_url || item.thumb_image || '',
                type: typeName,
                publishTime: item.update_time_at || item.day || item.created_at || '最近更新',
                categoryText: item.category_text || typeName,
                statusText: item.serialize_status_text || '',
                viewCount: item.look_count || item.views || Math.floor(Math.random() * 800000),
                favoriteCount: item.collect_count || item.collects || Math.floor(Math.random() * 60000),
                is_new: Number(item.is_new) || 0,
                number: item.number,
                originalItem: item
              };
            });
            
            this.bookList = [...this.bookList, ...newData];
            
            // 自动加载旧版本图片的兼容逻辑（参考index.vue）
            this.$nextTick(() => {
              newData.forEach(item => {
                if (item.is_new === 0 && item.number) {
                  this.resetImgUrl(item.number + '_img', item.cover);
                }
              });
            });

            if (this.params.page < temp.last_page) {
              this.params.page++;
            } else {
              this.finished = true;
            }
          } else {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      }).catch(err => {
        console.error(err);
        this.loading = false;
        this.finished = true;
      });
    },
    // 处理图片错误兼容逻辑
    preView(blob, element) {
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
          const imgElement = document.getElementById(element);
          if (imgElement) {
              imgElement.src = e.target.result;
          }
      };
    },
    jsReadFiles(blob, element) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onload = function () {
          var result = new Blob([reader.result.slice(3)], { type: 'image/jpeg' });
          this.preView(result, element);
      }.bind(this);
    },
    resetImgUrl(imageobj, url) {
      if (!url) return;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.open("GET", url + '_.pdf', true);
      xmlhttp.responseType = "blob";
      xmlhttp.onreadystatechange = function () {
          if (xmlhttp.readyState === XMLHttpRequest.DONE) {
              if (xmlhttp.status === 200) {
                  this.jsReadFiles(xmlhttp.response, imageobj);
              } else {
                  console.error("Failed to load image", url);
              }
          }
      }.bind(this);
      xmlhttp.send(null);
    },
    // 格式化数字
    formatCount(count) {
      if (count >= 10000) {
        return (count / 10000).toFixed(1) + 'w';
      }
      return count;
    },
    // 跳转详情
    goToDetail(item) {
      
        this.$router.push(`/detail?id=${item.id}`);
      
    }
  }
};
</script>

<style lang="scss" scoped>
.searcn-new-book{
    font-size: 14px !important;
    color:#fff !important;
    border-radius: 4px !important;
    background:  linear-gradient(to bottom,#FF2,#FB0);
    // box-shadow: 2px 2px #b20a55;
    line-height: 30px;
    font-weight: 700;
    text-align: center;
    border-radius: 50px;
    width: 90px;
    height: 30px;
  
    
  }
/* 页面深色奢华背景 */
.book-container {
  min-height: 100vh;
//   background-color: #11121d;
  display: flex;
  flex-direction: column;
  color: #fff;
  padding-bottom: 90px; /* 为底部炫酷导航留出空间 */
}

/* ================= 炫酷底部导航 ================= */
.cyber-tabbar {
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  height: 64px;
  background: rgba(20, 22, 34, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 32px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255, 255, 255, 0.1);
  z-index: 100;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff; /* 默认状态下也改为白色 */
  opacity: 0.9; /* 默认状态降低透明度以区分选中 */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 60px;
  position: relative;
  
  .tab-icon {
    font-size: 22px;
    margin-bottom: 4px;
    transition: transform 0.3s;
    color:#fff;
  }
  
  .tab-text {
    font-size: 10px;
    font-weight: 500;
    transition: all 0.3s;
    color:#fff;
  }
  
  &.active {
    opacity: 1; /* 选中状态完全不透明，高亮白色 */
    
    .tab-icon {
      transform: translateY(-4px) scale(1.1);
      color: #fff; /* 保持白色 */
      text-shadow: 0 0 10px rgba(255, 255, 255, 0.6); /* 换成白色外发光 */
    }
    
    .tab-text {
      transform: translateY(-2px);
      color: #fff; /* 保持白色 */
      font-weight: bold;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #fff; /* 白点指示器 */
      box-shadow: 0 0 8px #fff;
    }
  }
  
  &:active {
    transform: scale(0.9);
  }
}

/* 覆盖导航栏样式 */
::v-deep .dark-nav {
  background-color: #ffffff !important;
  border-bottom: 1px solid #f2f3f5;
  .van-nav-bar__title {
    color: #323233 !important;
    font-weight: bold;
  }
  .van-icon {
    color: #323233 !important;
  }
  &::after {
    display: none;
  }
}

/* ================= 分类区域 ================= */
.category-container {
  background-color: #ffffff;
  padding: 10px 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.main-category {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f3f5;
  
  .main-cat-item {
    font-size: 16px;
    color: #646566;
    font-weight: 500;
    padding-bottom: 4px;
    position: relative;
    transition: all 0.3s;
    
    &.active {
      color: #323233;
      font-weight: bold;
      font-size: 17px;
      
      &::after {
        content: '';
        position: absolute;
        bottom: -11px;
        left: 50%;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background-color: #ee0a24; /* Vant主题红 */
        border-radius: 2px;
      }
    }
  }
}

.sub-category-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4列适合4个字的分类名 */
  gap: 10px;
}

.sub-cat-tag {
  background-color: #f7f8fa;
  color: #323233;
  font-size: 13px;
  text-align: center;
  padding: 8px 4px;
  border-radius: 6px;
  transition: all 0.2s;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  &.active {
    background-color: #fdebee; /* 浅红底色 */
    color: #ee0a24; /* 主题红 */
    font-weight: bold;
  }
  
  &:active {
    opacity: 0.7;
  }
}

/* ================= 列表区域 ================= */
.list-container {
  flex: 1;
  padding: 0 12px;
}

.book-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

/* ================= 单个卡片 ================= */
.book-card {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #f8f8f8;
  transition: transform 0.2s;
  
  &:active {
    transform: scale(0.98);
  }
}

.cover-wrapper {
  position: relative;
  width: 100%;
  height: 140px; /* 固定高度 140px */
  
  .cover-img {
    width: 100%;
    height: 100%;
    display: block;
  }
  
  /* 左上角类型角标 */
  .type-badge {
    position: absolute;
    top: 6px;
    left: 6px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    background-color: rgba(247, 156, 38, 0.9); /* 橙色半透明 */
    z-index: 1;
    backdrop-filter: blur(4px);
  }
  
  /* 右上角状态角标 */
  .status-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    background-color: rgba(7, 193, 96, 0.9); /* 绿色半透明，代表连载/完结状态 */
    z-index: 1;
    backdrop-filter: blur(4px);
  }
}

.book-info {
  padding: 6px;
  display: flex;
  flex-direction: column;
  flex: 1;
  
  .book-title {
    font-size: 12px;
    font-weight: bold;
    // color: #fff;
    line-height: 1.4;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .book-time {
    font-size: 10px;
    color: #8a8e9f;
    margin-bottom: 6px;
  }
  
  .book-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;
    
    .stat-item {
      font-size: 10px;
      color: #8a8e9f;
      display: flex;
      align-items: center;
      gap: 4px;
      
      .star-icon {
        color: #f79c26; /* 收藏星标稍微高亮 */
      }
    }
  }
}

/* ================= 刷新组件深色定制 ================= */
::v-deep .dark-refresh {
  .van-pull-refresh__track {
    min-height: 50vh;
  }
  .van-pull-refresh__head,
  .van-list__loading,
  .van-list__finished-text {
    color: #8a8e9f;
  }
}

/* ================= 收藏站点弹窗样式 ================= */
.remind-box {
  position: relative;
  padding-bottom: 20px;
  background: #fff;
  border-radius: 16px 16px 0 0;
}
.remind-title-tips {
  font-weight: 600;
  color: #f53036;
  margin: 16px 24px 8px;
  font-size: 16px;
  line-height: 1.6;
  text-align: center;
}
.remind-box-title {
  margin: 0 auto;
  width: 100%;
  padding: 15px 0;
  font-size: 20px;
  background: #fff;
  color: #333;
  display: flex;
  justify-content: center;
  font-weight: 700;
  border-bottom: 1px solid #f5f5f5;
}
.remind-box-tip1 {
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #333;
}
.qrcode-section {
  margin-top: 10px;
  text-align: center;
}
.qrcode-wrapper {
  position: relative;
  display: inline-block;
  margin-top: 10px;
}
.remind-poster-img {
  width: 180px;
  height: 180px;
  background: #fff;
}
.remind-box-link {
  display: flex;
  justify-content: center;
  align-items: center;
}
.box-link {
  font-size: 18px;
  font-weight: 600;
  color: #44A4FF;
}
.box-copy {
  font-size: 14px !important;
  color: #fff !important;
  background: linear-gradient(#44A4FF, #44A4FF);
  font-weight: 700;
  text-align: center;
  border-radius: 20px;
  padding: 4px 12px;
  margin-left: 20px;
}

/* ================= 找回弹窗样式 ================= */
.code-box-card {
  width: 320px;
  border-radius: 10px;
  min-height: 320px;
  padding: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .code-box-title {
    width: 300px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
  }
  .code-content {
    background: #f8f8f8;
    margin: 20px 30px;
    padding: 20px;
    border-radius: 15px;
    color: rgb(107 114 128);
    width: 280px;
    .code-txt {
      color: rgb(107 114 128);
    }
    .code-input {
      height: 40px;
      border: none;
      margin-top: 20px;
      width: 100%;
      padding-left: 10px;
      border-radius: 5px;
      color: rgb(107 114 128);
    }
  }
  .code-tips {
    color: rgb(107 114 128);
    font-size: 14px;
    padding: 0 15px;
  }
  .code-btn {
    width: 250px;
    border-radius: 5px;
    color: #fff;
    margin: 20px auto;
  }
  .btn-grad1 {
    background-image: linear-gradient(to right, #FF8008 0%, #FFC837 51%, #FF8008 100%);
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
    display: block;
  }
  .btn-grad1:hover {
    background-position: right center;
    color: #fff;
    text-decoration: none;
  }
}
.cebian{
    position: fixed; /* 固定位置 */
    right:0px; /* 距离屏幕右侧10px */
    bottom: 0px;
    margin-bottom: 60px;
    transform: translateY(-50%); /* 垂直居中 */
    z-index: 1000; /* 确保在页面上方显示 */
    
    .ce-shesu{
      width: 50px;
      height: 50px;
      background-image: linear-gradient(to right, #FF8008 0%, #FFC837 51%, #FF8008 100%);
      color: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 600;
    }
  }
</style>
